import { useState } from 'react';

import { RoundedButtonGroup, ErrorMessage, UiInput } from 'ui-kit';
import { PredefinedOrCustomParameter } from './BidDetails';

export interface SelectPercentageProps {
  options: number[];
  selectedOption: PredefinedOrCustomParameter;
  setSelectedOption: (value: PredefinedOrCustomParameter) => void;
  customMin?: number;
  customMax?: number;
}

const SelectPercentage = ({
  options,
  selectedOption,
  setSelectedOption,
  customMin = 0,
  customMax = 100,
}: SelectPercentageProps) => {
  const [_customInputValue, setCustomInputValue] = useState<string>('');

  const updateCustomValue = (value: string) => {
    setCustomInputValue(value);
    setSelectedOption({ isCustom: true, value: value, draftValue: value });
  };

  const isValidCustomValue = () => {
    if (selectedOption.draftValue === '') return false;
    const valueAsNumber = Number(selectedOption.draftValue);
    return valueAsNumber >= customMin && valueAsNumber <= customMax;
  };

  const isError = selectedOption.isCustom && !isValidCustomValue();

  const buttonItems = [
    ...options.map((optionValue) => ({
      value: optionValue,
      label: `${optionValue}%`,
      isSelected: !selectedOption.isCustom && optionValue === Number(selectedOption.value),
      onClick: () =>
        setSelectedOption({
          isCustom: false,
          value: '' + optionValue,
          draftValue: selectedOption.draftValue,
        }),
    })),
    {
      value: 'custom',
      label: 'Custom',
      isSelected: selectedOption.isCustom,
      onClick: () =>
        setSelectedOption({
          isCustom: true,
          value: selectedOption.draftValue,
          draftValue: selectedOption.draftValue,
        }),
    },
  ];

  return (
    <div className="w-full">
      <div className="my-[10px] flex items-center">
        <RoundedButtonGroup items={buttonItems} buttonSize="medium" />
        <div className="ml-2.5 min-w-0 flex-1 pt-0.5">
          <UiInput
            type="number"
            variant="light"
            size="large"
            disabled={!selectedOption.isCustom}
            error={isError}
            value={'' + selectedOption.draftValue}
            suffix="%"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              updateCustomValue(event.target.value)
            }
            containerClass="w-full"
          />
          <ErrorMessage>
            {isError && (
              <span>
                Value between {customMin}-{customMax}%
              </span>
            )}
          </ErrorMessage>
        </div>
      </div>
    </div>
  );
};

export default SelectPercentage;
